import {Directive, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[fileDragDrop]'
})
export class DragDropDirective {

  @Output() fileDropped = new EventEmitter<File[]>();

  @HostBinding('class.drag-hover') hoverClass = false;

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt: Event) {
    evt.preventDefault();
    evt.stopPropagation();

    this.hoverClass = true;
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event'])
  public onDragLeave(evt: Event) {
    evt.preventDefault();
    evt.stopPropagation();

    this.hoverClass = false;
  }

  // Drop listener
  @HostListener('drop', ['$event'])
  public ondrop(evt: Event) {
    evt.preventDefault();
    evt.stopPropagation();

    this.hoverClass = false;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const files = evt.dataTransfer.files as File[];

    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }

}
